export const DEFAULT_SEARCH_DEBOUNCE_MS = 200; // Avoid searching on every keystroke.
